import { render, staticRenderFns } from "./OnboardHotel.vue?vue&type=template&id=752df22c&"
import script from "./OnboardHotel.vue?vue&type=script&lang=js&"
export * from "./OnboardHotel.vue?vue&type=script&lang=js&"
import style0 from "./OnboardHotel.vue?vue&type=style&index=0&id=752df22c&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752df22c')) {
      api.createRecord('752df22c', component.options)
    } else {
      api.reload('752df22c', component.options)
    }
    module.hot.accept("./OnboardHotel.vue?vue&type=template&id=752df22c&", function () {
      api.rerender('752df22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/OnboardHotel.vue"
export default component.exports